import React, { memo } from 'react';
import { Grid, Icon } from 'semantic-ui-react';

/**
 * PortfoliosListEnh component
 * Enhanced portfolio list component for the voice actor worksheet
 * @param {Object} props - Component props
 * @param {Array} props.portfolios - Array of portfolio objects
 * @param {string} props.selectedPortfolioId - Currently selected portfolio ID
 * @param {Function} props.onSelectPortfolio - Callback when a portfolio is selected
 * @param {Function} props.onDeletePortfolio - Callback when delete icon is clicked
 * @returns {JSX.Element} PortfoliosListEnh component
 */
const PortfoliosListEnh = memo(({
  portfolios = [],
  selectedPortfolioId,
  onSelectPortfolio,
  onDeletePortfolio
}) => {
  console.log('[PORTFOLIOS_LIST] Rendering with:', {
    portfolioCount: portfolios.length,
    selectedPortfolioId,
    portfolios: portfolios.map(p => ({ uuid: p.uuid, name: p.name }))
  });

  return (
    <div style={{ marginTop: '15px' }}>
      {/* Header row */}
      <Grid>
        <Grid.Row style={{ fontWeight: 'bold', borderBottom: '1px solid #ddd', padding: '10px 0' }}>
          <Grid.Column width={12}>Portfolio Name</Grid.Column>
          <Grid.Column width={4}>Actions</Grid.Column>
        </Grid.Row>

        {/* Portfolio rows */}
        {portfolios.length === 0 ? (
          <Grid.Row style={{ padding: '20px 0', textAlign: 'center' }}>
            <Grid.Column width={16}>
              <p style={{ color: '#888' }}>No portfolios found. Create a new portfolio to get started.</p>
            </Grid.Column>
          </Grid.Row>
        ) : (
          portfolios.map((portfolio) => (
            <Grid.Row
              key={portfolio.uuid}
              style={{
                padding: '10px 0',
                backgroundColor: selectedPortfolioId === portfolio.uuid ? '#f9fafb' : 'transparent',
                cursor: 'pointer',
                borderBottom: '1px solid #eee'
              }}
              onClick={() => {
                console.log('[PORTFOLIOS_LIST] Portfolio selected:', portfolio.uuid, portfolio.name);
                onSelectPortfolio(portfolio);
              }}
            >
              <Grid.Column width={12}>
                <div>
                  <strong>{portfolio.name}</strong>
                  {portfolio.description && (
                    <div style={{ fontSize: '0.9em', color: '#666', marginTop: '2px' }}>
                      {portfolio.description.length > 60
                        ? `${portfolio.description.substring(0, 60)}...`
                        : portfolio.description
                      }
                    </div>
                  )}
                  {portfolio.status && (
                    <div style={{ fontSize: '0.8em', color: '#888', marginTop: '2px' }}>
                      Status: {portfolio.status}
                    </div>
                  )}
                </div>
              </Grid.Column>
              <Grid.Column width={4} textAlign="right">
                <Icon
                  name="trash alternate"
                  color="red"
                  className="trash-icon"
                  style={{ cursor: 'pointer' }}
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent row selection
                    console.log('[PORTFOLIOS_LIST] Delete clicked for portfolio:', portfolio.uuid);
                    onDeletePortfolio(portfolio);
                  }}
                />
              </Grid.Column>
            </Grid.Row>
          ))
        )}
      </Grid>
    </div>
  );
});

PortfoliosListEnh.displayName = 'PortfoliosListEnh';

export default PortfoliosListEnh;
